export function shouldUseAnchorTag(to, forceRefresh) {
    const lowerCasedTo = to.toLowerCase();
    if (forceRefresh)
        return true;
    if (lowerCasedTo.startsWith('http'))
        return true;
    if (lowerCasedTo.startsWith('mailto'))
        return true;
    if (lowerCasedTo.startsWith('tel'))
        return true;
    if (lowerCasedTo.startsWith('\\'))
        return true;
    return false;
}
//# sourceMappingURL=Link.utils.js.map